import service from '../services/request'

// 个人获取答卷列表
export const getListByUid = function (params) {
  return service({
    method: 'get',
    url: '/answer/getListByUid',
    params
  })
}

// 是否有答题资格
export const getJudge = function (params) {
  return service({
    method: 'get',
    url: '/answer/getJudge',
    params
  })
}

// 新建答卷
export const insertAnswer = function (data) {
  return service({
    method: 'post',
    url: '/answer/insertAnswer',
    data
  })
}
// 新建答卷
export const checckJudge = function (params) {
  return service({
    method: 'get',
    url: '/answer/getIsJudge',
    params
  })
}
